import React from 'react';
import { Link } from 'react-router-dom';

interface NavbarLogoProps {
  scrolling: boolean;
  useWhiteText: boolean;
  logoImageOrange: string;
  logoImageWhite: string;
  logoImageGrey: string;
  onLogoClick: () => void;
}

const NavbarLogo: React.FC<NavbarLogoProps> = ({
  scrolling,
  useWhiteText,
  logoImageOrange,
  logoImageWhite,
  logoImageGrey,
  onLogoClick
}) => {
  const logoSrc = scrolling ? logoImageOrange : useWhiteText ? logoImageWhite : logoImageGrey;

  return (
    <Link to="/" onClick={onLogoClick}>
      <div className="navbar-logo">
        <img className='navbar-logo-img' src={logoSrc} alt="logo" />
      </div>
    </Link>
  );
};

export default NavbarLogo;
